import React, { useEffect, useState, useContext } from 'react';
import moment from 'moment';
import Modal from '../components/modal/modal.component';
import Card from '../components/card.component';
import guiasFunction from '../views/entrega/entrega.functions';
import { ConfigContext } from '../context/config.context';

const EstadoPaquete = ({ guia, onClose }) => {

  const {config} = useContext(ConfigContext);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(true);

  const toggle = () => {
      setVisible(!visible)
  }

  useEffect(() => {
    if (guia) {
        setVisible(true);
    }
  },[guia]);

  useEffect(() => {
    if (visible) {
        guiasFunction.listadoEstadosPorGuia(guia.id)
          .then((response) => {
            const arrayData = response.data.reverse()
            setData(arrayData);
            setLoad(false);
          })
    } else {
        setData([]);
        onClose();
    }
  // eslint-disable-next-line
  },[visible]); 

  
  const ultimoElemento = (arreglo, position) => {
    return position === 0 ? 'Estado actual' : 'Procesado';
  }

  const styleEstado = (texto) => {
    const estiloActivo = {
      backgroundColor: 'limegreen',
      padding:'2px 5px',
      borderRadius: '3px',
      fontSize: '14px',
    };
    const estiloProcesado = {
      backgroundColor: '#80e580',
      padding:'2px 5px',
      borderRadius: '3px',
      fontSize: '14px',
      color: '#787676',
    };
    return texto === 'Estado actual' ? estiloActivo : estiloProcesado;
  }


  return (
    <>
    {guia ? 
      <Modal size="lg" show={visible}>
        <Card>
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <p style={{ fontWeight: 'bold', paddingBottom: 10 }}>Tracking guia {`${config.prefijo_correlativo_guia}-${guia.guia}`}</p>
            {load ? 
            <div className="empty-status">
                <p>Cargando datos...</p>
            </div>
            :
            <div className="scroll-status">
                <ul style={{ minHeight: 320 }}>
                    {data.map((item, key) => {
                        return <div className="border-status" key={key}>
                          <p style={{ marginBottom: '0.2rem' }}>
                            <b>Fecha:</b> {moment(item.createdAt).format('DD/MM/YYYY')}  -  
                            <span style={styleEstado(ultimoElemento(data, key))}>{ultimoElemento(data, key)}</span>
                          </p>
                          <p style={{ marginBottom: '0.2rem' }}>
                            <b>Descripción:</b> {item.descripcion}
                          </p>
                        </div>
                    })}
                </ul>
            </div>
            }
          </div>
          <div>
            <button 
              onClick={toggle}
              type="button"
              className="btnx btnx-warn"
            >
              Cerrar
            </button>
          </div>
        </Card>
      </Modal>
    : null }
    </>
  )
}

export default EstadoPaquete;